import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import {
  getLastLeaveResetYear,
  getPunchData,
  ProcessEmpLeave,
  ProcessPunch,
  PunchRecordsProcess,
  ResetEmployeeUpdatedLeave,
} from "../../services/dataService";
import Loading from "../../components/common/Loading";
import Breadcrumb from "../../components/common/Breadcrumb";
import { getSecureItem } from "../../services/SecureStorage";

function PunchProcess() {
  const UID = getSecureItem("userId");
  const [loading, setLoading] = useState(false);
  const [resetedYear, setResetedYear] = useState([]);
  const [clicked, setClicked] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const handleClick = async () => {
    setLoading(true);
    setShowModal(false);

    try {
      const res = await ResetEmployeeUpdatedLeave(UID);

      console.log("Reset Response:", res);

      if (res?.data?.status === "success") {
        toast.success("Leaves reset successfully!");
        await fetchLastLeaveResetYear();
        setClicked(true);
      } else {
        toast.error(res?.data?.message || "Something went wrong.");
      }
    } catch (err) {
      toast.error("Server error");
    } finally {
      setLoading(false);
    }
  };

  const fetchLastLeaveResetYear = async () => {
    try {
      const response = await getLastLeaveResetYear(UID);
      setResetedYear(response.data.year);
    } catch (error) {
      console.error("Error fetching leave reset year:", error);
    }
  };

  const currentYearReset = new Date().getFullYear() - 1;
  const disableBtn = currentYearReset == resetedYear;
  const isDecember31 = true;

  useEffect(() => {
    console.log(currentYearReset, resetedYear, isDecember31, "fa");
  }, [currentYearReset, resetedYear, isDecember31]);

  useEffect(() => {
    fetchLastLeaveResetYear();
  }, []);

  const [puchdata, setPunchData] = useState([]);

  const handlegetPuchData = async () => {
    const data = {
      UserId: UID,
      currentDate: new Date().toISOString().split("T")[0],
    };

    try {
      const resp = await getPunchData(data);
      setPunchData(resp.data.data);
      console.log(resp.data.data);
    } catch {}
  };

  useEffect(() => {
    console.log(puchdata);
    handlegetPuchData();
  }, []);

  const hasUnprocessedRecords = puchdata.some(
    (el) => el.Processed == false && (el.Direction == 0 || el.Direction == 1)
  );

  useEffect(() => {
    console.log("hasUnprocessedRecords", hasUnprocessedRecords);
  }, [hasUnprocessedRecords]);

  const handlepunchrecordsprocess = async () => {
    if (loading) return;
    setLoading(true);

    const data = { UserId: UID };

    try {
      const response = await PunchRecordsProcess(data);
      console.log(response, "Response Log");

      console.log(hasUnprocessedRecords, "dasasas");

      if (response) {
        toast.success("Processed Successfully");
        handlegetPuchData();
      }
    } catch (error) {
      console.error(error, "Error occurred during processing");
      toast.error("An error occurred while processing the data");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Breadcrumb title="" />
      <div className="flex min-h-screen bg-gray-100 p-4">
        <div className="flex flex-wrap gap-8 w-full justify-center">
          {/* Punch Records Button */}
          <div className="max-w-lg w-full relative">
            <p className="absolute top-0 left-0 text-gray-600 text-sm font-semibold">
              Click here to process punch records
            </p>

            <div className="bg-white shadow-lg rounded-2xl p-6 mt-6">
              <button
                onClick={handlepunchrecordsprocess}
                disabled={loading}
                className={`w-full py-2 px-4 bg-green-500 rounded-lg text-lg font-medium transition duration-300 
            ${
              loading
                ? "bg-gray-400 cursor-not-allowed"
                : "bg-blue-600 hover:bg-blue-700"
            }`}
              >
                {loading ? "Processing..." : "Punch Records"}
              </button>
            </div>
          </div>

          {/* Process Leave Button */}
          <div className="max-w-lg w-full relative">
            <p className="absolute top-0 left-0 text-gray-600 text-sm font-semibold">
              Click here to Process Employee Leaves
            </p>

            <div className="bg-white shadow-lg rounded-2xl p-6 mt-6">
              <button
                onClick={() => setShowModal(true)}
                disabled={loading || currentYearReset == resetedYear}
                className={` w-full
    py-2 px-4 rounded text-black font-semibold transition
    ${
      loading || !(isDecember31 && currentYearReset !== resetedYear)
        ? "bg-gray-400 cursor-not-allowed"
        : "bg-green-600 hover:bg-green-700"
    }
  `}
              >
                {loading ? "Processing..." : clicked ? "Done" : "Reset leaves"}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Confirmation Modal */}
      {showModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
          {/* Backdrop with blur */}
          <div 
            className="absolute inset-0  bg-opacity-50 backdrop-blur-sm"
            onClick={() => setShowModal(false)}
          ></div>
          
          {/* Modal Content */}
          <div className="relative bg-white rounded-2xl shadow-2xl p-8 max-w-md w-full mx-4 transform transition-all">
            <div className="text-center">
              {/* Warning Icon */}
              <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-yellow-100 mb-4">
                <svg
                  className="h-10 w-10 text-yellow-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                  />
                </svg>
              </div>

              {/* Modal Title */}
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                Are you sure?
              </h3>

              {/* Modal Message */}
              <p className="text-gray-600 mb-8 leading-relaxed">
Reset this year's leaves? This will remove all Permanent Category leaves for the current year and automatically add them for the next year.              </p>

              {/* Action Buttons */}
              <div className="flex gap-4">
                <button
                  onClick={() => setShowModal(false)}
                  className="flex-1 px-6 py-3 bg-gray-200 hover:bg-gray-300 text-gray-800 font-semibold rounded-lg transition duration-200"
                >
                  Cancel
                </button>
                <button
                  onClick={handleClick}
                  className="flex-1 px-6 py-3 bg-red-600 hover:bg-red-700 text-white font-semibold rounded-lg transition duration-200"
                >
                  Yes, Reset
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default PunchProcess;